import { createI18n } from 'vue-i18n';
import config from "@/utils/config"
import { getStorage, setStorage } from "@/utils"

import en from "./en.json";
import tw from "./zh-TW.json"
import vi from "./vi.json";
import es from "./es.json"

export const i18nMessage = {
  en: {
    ...en
  },
  vi,
  es,
  tw: {
    ...tw
  }
}

export const lans = [{
  label: "English",
  value: "en"
}, {
  label: 'Việt Nam',
  value: 'vi'
},
{
  label: 'Español',
  value: 'es'
},
  // {
  //   label: "繁体中文",
  //   value: "tw"
  // }
]

export const t = (key, spareKey = "") => {
  return i18n.global.t(key, spareKey)
}

export function getLanguage() {
  let chooseLanguage = getStorage("lang");

  if (!lans.find(item => item.value == chooseLanguage)) {
    chooseLanguage = config.lang;
    setLanguage(chooseLanguage)
  }
  if (!chooseLanguage) {
    setLanguage(config.lang)
  }
  return chooseLanguage || config.lang
}


let i18n = null;
let i18nConfig = {
  locale: getLanguage(),
  messages: i18nMessage
}

i18n = createI18n(i18nConfig);

export function setLanguage(lang) {
  i18n && (i18n.global.locale = lang);
  return setStorage('lang', lang)
}
export default i18n;